<!-- Mobile Gallery -->
<section class="center-slider-wrp video-img-slider mt-8 show-in-mobile-only deal-slider-wrp"
         *ngIf="appService.isMobile && product">
  <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">

    <ul class="uk-slider-items uk-grid-match mob-sli" uk-lightbox="animation:scale">
      <li class="uk-width-3-4" *ngFor="let image of product.product_images">
        <div class="uk-panel">
          <a href="{{image.images}}" data-caption="">
            <img src="{{image.images}}" class="img-width" alt="{{image.title}}">
          </a>
        </div>
      </li>
    </ul>

    <a class="btn-view-all formobilesli" (click)="openSlideShow()">
      <img src="assets/images/icons/gallery-icon.png"> Show All
    </a>

    <a class="uk-position-center-left uk-position-small hideMobilex" href="#" uk-slidenav-previous
       uk-slider-item="previous"></a>
    <a class="uk-position-center-right uk-position-small hideMobilex" href="#" uk-slidenav-next
       uk-slider-item="next"></a>

    <div class="hidelg">
      <div class="back-link uk-flex uk-flex-between">
        <a [routerLink]="['/'+this.pageCity+'/deals']">
          <img src="assets/images/icons/white-arrow.png" alt="">
        </a>
        <div class="share-box">
          <a class="sharing-link">
            <img src="assets/images/icons/share-white.png" alt="" (click)="openShareLink()">
            <div class="sharelink uk-flex" *ngIf="product">
              <share-buttons [theme]="'default'"
                             [include]="['facebook','twitter','telegram','whatsapp','sms','email']"
                             [show]="9" [size]="1" [url]="pageURL" [image]="pageFeaturedImage"
                             [autoSetMeta]="false"></share-buttons>
            </div>
          </a>
          <a>
            <app-wishlist [productData]=product></app-wishlist>
          </a>
        </div>
      </div>
    </div>

    <ul class="progress-donut hidelg">
      <li uk-slider-item="{{i+1}}" *ngFor="let image of product.product_images; let i = index">
        <a href="#"></a>
      </li>
    </ul>

  </div>


</section>

<!--Main gallery starts here-->
<section class="images-section mt-8" *ngIf="(appService.isDesktopDevice || appService.isTablet)">
  <div class="container">
    <div class="gallery uk-flex">
      <div class="gallery-item item-left" uk-lightbox="animation:scale">

        <!-- first 5 images will be with images -->
        <a href="{{image.images}}" data-caption="" *ngFor="let image of productVisibleImages">
          <img src="{{image.images}}" alt="{{image.title}}">
        </a>

        <a href="{{image.images}}" data-caption="" *ngFor="let image of productHiddenImages">
        </a>


        <a href="{{image.images}}" class="btn-view-all" *ngFor="let image of productGalleryFirstImage">
          <img src="assets/images/icons/gallery-icon.png"> Show All
        </a>
      </div>
    </div>
  </div>
</section>
<!--Main gallery ends here-->

<!--LOADER-->
<section class="images-section mt-8" *ngIf="(appService.isDesktopDevice || appService.isTablet) && !product">
  <div class="container">
    <ngx-skeleton-loader animation="progress" appearance="line">
    </ngx-skeleton-loader>
  </div>
</section>


<!--Info section starts here-->
<section class="info-section mb-2 mt-4" *ngIf="product">
  <div class="container">
    <div class="uk-flex container-inner">
      <div class="w-70">
        <div class="key-highlight-info">
          <div class="location-bar uk-animation-fade">
            <div>
              <span class="location-pin icon">
                <!--<img src="assets/images/icons/location-black.png"/>-->
                <i class="fa fa-map-marker"></i>
              </span>
              <span class="place">
                              {{product.details.sub_locality ? product.details.sub_locality : product.details.city}}
                            </span>
              <a class="icon-anchor sharing-link">
                <span class="fa fa-share-alt icon opensharelink" (click)="openShareLink()"></span>
                <div class="sharelink uk-flex" *ngIf="product">
                  <share-buttons [theme]="'default'"
                                 [include]="['facebook','twitter','telegram','whatsapp','sms','email']"
                                 [show]="9" [size]="1" [url]="pageURL" [image]="pageFeaturedImage"
                                 [autoSetMeta]="false"></share-buttons>
                </div>
              </a>
              <app-wishlist [productData]=product></app-wishlist>
            </div>
            <div class="title-bar">
              <h1 class="location-title">{{product.details.title}}</h1>
              <p class="location-type">{{product.details.category_name}}</p>
            </div>
            <div class="location-logo">
              <img src="{{product.details.logo}}" alt="{{product.details.title}}" loading="lazy"/>
            </div>
          </div>
          <hr/>
          <div class="location-copy">
            <p>
              {{product.details.description}}
            </p>
          </div>
          <div class="experience-selection">
            <div class="experience-header">
              <h2 class="experience-title">Select your Experience</h2>
            </div>
          </div>
        </div>

        <!--veg nonveg switch button section starts here-->
        <div class="uk-flex veg-non-veg-section uk-animation-fade" *ngIf="product.deal_veg_non_veg">
          <div class="food-label veg-label">
            <label class="switch" for="checkbox">
              <input type="checkbox" id="checkbox" [(ngModel)]="vegCheckBox"
                     (change)="onVegSelectChange($event.target)"/>
              <div class="slider round"></div>
            </label>
            <span class="veg-copy">Veg</span>
          </div>
          <div class="food-label non-veg-label">
            <label class="switch" for="checkbox1">
              <input type="checkbox" id="checkbox1" [(ngModel)]="nonVegCheckBox"
                     (change)="onNonVegSelectChange($event.target)"/>
              <div class="slider round"></div>
            </label>
            <span class="non-veg-copy">Non - Veg</span>
          </div>
        </div>
        <!--veg nonveg switch button section ends here-->

        <div class="selling-list" *ngIf="productDeals">
          <!--selling item starts here-->
          <div class="selling-item {{ this.selectedDeal && deal.deal_id === this.selectedDeal.deal_id ?'selected':''}}"
               *ngFor="let deal of productDeals">

            <div class="selling-item-container">

              <ng-container *ngIf="deal.tag">

                <div class="trending bg-womensday" *ngIf="deal.tag.title == 'Women\'s Day'">
                  <img src="assets/images/icons/women-tag.png" alt="">
                  <span>Women's Day</span>
                </div>

                <div class="trending bg-orange" *ngIf="deal.tag.title == 'Hot Selling'">
                  <img src="assets/images/icons/fire.png" alt="">
                  <span>Hot Selling</span>
                </div>

                <div class="trending bg-red" *ngIf="deal.tag.title == 'Valentine Special'">
                  <img src="assets/images/icons/heart-2.png" alt="">
                  <span>Valentine Special</span>
                </div>

                <div class="trending bg-purple" *ngIf="deal.tag.title == 'Limited Stock'">
                  <img src="assets/images/icons/stock.png" alt="">
                  <span>{{deal.tag.title}}</span>
                </div>
                <div class="themeDealTags bg-christmasTag" *ngIf="deal.tag.title == 'Christmas Bash'">
                  Christmas Bash
                </div>

                <div class="themeDealTags bg-newYearTag" *ngIf="deal.tag.title == 'New Year'">
                  New Year's Bash
                </div>

                <div class="trending bg-deal-pe-deal" *ngIf="deal.tag.title == 'Deal Pe Deal'">
                  <img src="assets/images/icons/deal-pe-deal-icon.png" alt="">
                  <span>Weekend Deals</span>
                </div>

                <div class="trending bg-delivery-box" *ngIf="deal.tag.title == 'Delivery Boxes'">
                  <img src="assets/images/icons/delivery-box-icon.png" alt="">
                  <span>Delivery boxes</span>
                </div>

                <div class="trending bg-dine-in-deal" *ngIf="deal.tag.title == 'Dine-in Deals'">
                  <img src="assets/images/icons/dine-in-icon.png" alt="">
                  <span>Dine-in Deals</span>
                </div>
              </ng-container>

              <div class="uk-flex uk-flex-middle christmasTheme">
                <div class="offer-section">
                  <p class="offer-copy">{{deal.deal_title}} </p>
                  <p class="buffet-copy">{{deal.deal_sub_title}}</p>
                  <!-- <p class="buffet-copy"></p>-->
                  <div class="people-count">
                    <p *ngIf="deal.deal_valid_for">Valid for  {{deal.deal_valid_for}} ({{deal.deal_valid_on}})</p>
                  </div>
                  <div class="validity">
                    <span class="validity-timing">Valid timing :</span>
                    <select>
                      <option *ngFor="let timing of deal.deal_valid_timings" value="{{timing}}"> {{timing}}</option>
                    </select>
                  </div>

                  <div class="modal-block">
                    <a class="more-details" href="#modal-center-{{deal.deal_id}}" uk-toggle
                       *ngIf="deal.deal_details || deal.deal_t_c">More Details</a>
                    <div id="modal-center-{{deal.deal_id}}" class="uk-flex-top" uk-modal>
                      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical  more-popup">
                        <button class="uk-modal-close-default" type="button" uk-close></button>
                        <div class="popover-modal-details">
                          <ul class="uk-subnav uk-subnav-pill" uk-switcher>
                            <li *ngIf="deal.deal_details"><a>Menu</a></li>
                            <li *ngIf="deal.deal_t_c"><a>Fine Print</a></li>
                          </ul>
                          <ul class="uk-switcher uk-margin popover-details">
                            <li [innerHTML]="deal.deal_details" *ngIf="deal.deal_details"></li>
                            <li>
                              <p [innerHTML]="deal.deal_t_c" *ngIf="deal.deal_t_c">
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="show-in-mobile"/>
                </div>


                <div class="price-section">
                  <div class="">

                    <div class="prices">
                      <p class="striked" *ngIf="deal.deal_regular_price">
                        <i class="fa fa-rupee"></i> {{deal.deal_regular_price | currency:'INR':'':'1.0-0'}}
                      </p>
                      <p class="current-price">
                        <i class="fa fa-rupee"></i> {{deal.deal_sale_price | currency:'INR':'':'1.0-0'}}
                        <span>Incl. all taxes</span>
                      </p>
                    </div>

                    <ng-container *ngIf="deal.deal_stock > 0">
                      <!--04 Jan-->
                      <button class="switch-btn" (click)="selectExperience(product, deal)" *ngIf="deal != selectedDeal">
                        <span>Add</span>
                        <span>+</span>
                      </button>


                      <div class="counter-wrp" *ngIf="deal == selectedDeal">
                        <div class="number">
                          <div class="number">
                            <span class="minus" (click)="decreaseQty(deal)">-</span>
                            <input type="text" class="quantity-input" disabled value="1" [(ngModel)]="deal.quantity"/>
                            <span class="plus" (click)="increaseQty(deal)">+</span>
                          </div>
                        </div>
                      </div>
                      <!--04 Jan End-->

                      <!-- <div class="selection" *ngIf="appService.isDesktopDevice || appService.isTablet">
                          <label class="switcher" (click)="selectExperience(product, deal)">
                            <input type="radio"/>
                            <div class="sliderr roundd"></div>
                            <span class="select-copy select-copy1">Select</span>
                            <span class="select-copy select-copy2">Selected</span>
                          </label>
                      </div> -->
                    </ng-container>
                    <ng-container *ngIf="deal.deal_stock <= 0">
                      <div *ngIf="appService.isDesktopDevice || appService.isTablet">
                        <label class="btn-yellow btn-yellow-bold center-block">Sold Out</label>
                      </div>
                    </ng-container>
                  </div>


                </div>


                <ng-container *ngIf="deal.deal_stock <= 0">
                  <div *ngIf="appService.isMobile || appService.isTablet">
                    <label class="btn-yellow btn-yellow-bold center-block">
                      Sold Out
                    </label>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <!--selling item ends here-->

          <!--LOADER-->

          <!--
<div class="selling-item">
  <div class="selling-item-container">
    <ngx-skeleton-loader animation="progress" appearance="line">
    </ngx-skeleton-loader>
  </div>
</div>
-->

          <div class="address-bar uk-animation-fade">
            <h3 class="address-title">Address</h3>
            <p class="address-copy">
              {{product.merchants.address}}
            </p>
          </div>
        </div>
      </div>

      <div class="w-30 hideMobile">
        <div class="guest-booking grey-bg sticky-section">

          <div class="if-empty text-center" *ngIf="!selectedDeal">
            <div class="empty-bar">
              <img src="assets/images/bag.png" alt="empty bag" loading="lazy"/>
            </div>
            <p class="missing-copy">Please add an option</p>
            <p class="small-copy">Your order is empty</p>
            <div class="btn-block">
              <a class="btn-yellow btn-full mt-3" disabled>Proceed to Pay</a>
            </div>
          </div>

          <div class="if-fillwed" *ngIf="selectedDeal && selectedDeal.deal_stock > 0">
            <div class="filled-heading">
              Your Selected <b>Experience</b>
            </div>
            <hr/>
            <p class="cart-buffet-copy">{{selectedDeal.deal_title}} {{selectedDeal.deal_sub_title}}</p>
            <p class="cart-quantity">QTY : {{selectedDeal.quantity}}</p>
            <p class="pay-copy">You Pay</p>
            <div class="prices">
              <p class="striked" *ngIf="selectedDeal.deal_regular_price">
                <i
                  class="fa fa-rupee"></i> {{selectedDeal.deal_regular_price * selectedDeal.quantity | currency:'INR':'':'1.0-0'}}
              </p>
              <p class="current-price">
                <i
                  class="fa fa-rupee"></i> {{selectedDeal.deal_sale_price * selectedDeal.quantity | currency:'INR':'':'1.0-0'}}
                <span>Incl. all taxes</span>
              </p>
            </div>
            <div class="btn-block text-center">
              <a class="btn-yellow btn-full mt-3" (click)="addToCart()">Proceed to Pay</a>
            </div>
          </div>
          <!--guest-card-->
        </div>

        <!--LOADER-->
        <!--
<div class="guest-booking grey-bg sticky-section">
  <ngx-skeleton-loader animation="progress" appearance="line">
  </ngx-skeleton-loader>
</div>
-->

      </div>
      <!--w-30-->
    </div>
  </div>
</section>


<section class="book-now-card uk-flex hidelg hidetab" *ngIf="appService.isMobile && selectedDeal">
  <div class="uk-flex uk-flex-between uk-flex-middle">
    <div class="price">
      <p class="striked" *ngIf="selectedDeal.deal_regular_price">
        <i
          class="fa fa-rupee"></i> {{selectedDeal.deal_regular_price * selectedDeal.quantity | currency:'INR':'':'1.0-0'}}
      </p>
      <p class="current-price">
        <i class="fa fa-rupee"></i> {{selectedDeal.deal_sale_price * selectedDeal.quantity | currency:'INR':'':'1.0-0'}}
        <br/>
        <span>Incl. all taxes</span>
      </p>

    </div>
    <div class="btn">
      <a class="btn-yellow" (click)="addToCart()">PROCEED TO PAY</a>
    </div>
  </div>
</section>

<!--NEW ARRIVED--->
<app-new-arrivals></app-new-arrivals>
